import { Component, Input } from '@angular/core'
import { AggregatedInventoryByMaterialNumber } from '../../../types/mpup-types'
import { MpupInventoryService } from '../../../services/mpup-inventory.service'
import { environment } from '../../../../../../environments/environment'

@Component({
  selector: 'mb-mpup-inventory-list-item',
  templateUrl: './mpup-inventory-list-item.component.html',
  styleUrls: ['./mpup-inventory-list-item.component.scss']
})
export class MpupInventoryListItemComponent {

  @Input()
  item!: AggregatedInventoryByMaterialNumber

  expanded = false
  productPageUrl = environment.mpup.productPageUrl

  constructor (private inventoryService: MpupInventoryService) {
  }

  toggleExpansion () {
    this.expanded = !this.expanded
  }

  getDataSheetUrl () {
    return this.inventoryService.getDataSheetUrl(this.item.materialNumber)
  }
}
